<template>
    <generic-dialog v-model="followingDialog" 
    title="Following"
    @input="!followingDialog ? $router.replace(`/${$route.params.username}/`) : ''">
        <following-list :userId="$route.params.username" style="height: 100%"></following-list>
    </generic-dialog>
</template>
<script>
import genericDialog from "@/components/dialogs/generic-dialog.vue"
import followingList from "@/components/list/list-following.vue"
export default {
    components: {
        'following-list': followingList,
        'generic-dialog': genericDialog
    },
    mounted() {
        this.followingDialog = true
    },

    data() {
        return {
            followingDialog: false
        }
    }
}
</script>